import { useState } from 'react';

import { UserManagementDetails } from '@pages/UserManagement/Details';
import type { UserItem } from 'api';
import { useGetCustomerUsers } from 'api';

import { useOrganisationId } from 'hooks/context';

import { DataTable } from 'components/ui/organisms/DataTable';

import { getColumns } from './columns';
import {
  USER_MANAGEMENT_TABLE_ROW_TEST_ID,
  USER_MANAGEMENT_TABLE_TEST_ID,
  USER_DETAILS_TEST_ID
} from './constants';

export const UserManagementTable = () => {
  const organisationId = useOrganisationId<number>();
  const [selectedRowData, setSelectedRowData] = useState<UserItem>();

  const { data: { data: users } = {}, isFetching } = useGetCustomerUsers(
    organisationId,
    {
      query: { queryKey: ['users', organisationId] }
    }
  );

  const userManagementColumns = getColumns();

  const handleRowClick = (record: UserItem) => {
    setSelectedRowData((selected) =>
      selected?.id !== record.id ? record : undefined
    );
  };

  return (
    <DataTable
      total={users?.length}
      dataSource={users}
      columns={userManagementColumns}
      onRowClick={handleRowClick}
      isLoading={isFetching}
      rowKey="id"
      selectedRow={selectedRowData}
      tableDataTestId={USER_MANAGEMENT_TABLE_TEST_ID}
      rowDataTestId={USER_MANAGEMENT_TABLE_ROW_TEST_ID}
      rightPanel={
        selectedRowData ? (
          <UserManagementDetails
            data-testid={USER_DETAILS_TEST_ID}
            key={selectedRowData.id}
            onClose={() => setSelectedRowData(undefined)}
            userId={selectedRowData.id}
          />
        ) : undefined
      }
    />
  );
};
